(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zoek-wisknop"] && !Shopify.designMode) return;
  try {
    // Wist het zoekveld naast het kruisje en zet de cursor er weer in.
  document.addEventListener('click', function (e) {
    var knop = e.target.closest('[data-zoek-wis]');
    if (!knop) return;
    var veld = knop.parentNode.querySelector('input[name="q"]');
    if (!veld) return;
    veld.value = '';
    veld.dispatchEvent(new Event('input', { bubbles: true }));
    veld.focus();
  });
  } catch(e) { console.error(e); }
})();

})();
